export default __webpack_public_path__ + "static/media/icon-em-pill-active.9bfaace6.svg";